export default __webpack_public_path__ + "static/media/hand_with_heart.190da5ea.svg";